'use strict';

require('document.contains/auto');